import api from ".";

export const viewWalletAccount = () => api.get("/wallet/account");

export const viewWalletBalance = () => api.get("/wallet/balance");

export const viewWalletTransactions = (params) => api.get("/wallet/transactions", { params });
